import { articleRecircPipeSeparator } from "@ui/components/content-cards/ContentBlock/components/ContentBlockMeta/ContentBlockMeta.css";
import { ContentBlockMetaConfig } from "@ui/context/component-config-context";
import { sharedStyles } from "@ui/shared-styles";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const contentBlockMetaConfig: RecursivePartial<ContentBlockMetaConfig> = {
  showAuthorBy: false,
  defaultSeparators: {
    upper: [
      sharedStyles.layout.spaceSeparator,
      sharedStyles.layout.pipeSeparator,
    ],
    lower: [
      sharedStyles.layout.spaceSeparator,
      sharedStyles.layout.pipeSeparator,
    ],
  },
  componentContext: {
    prominentContentCardRiver: {
      metaVariation: "standard",
    },
    compactContentCardThreeGridArticleCategoryRecirc: {
      defaultSeparators: {
        upper: [sharedStyles.layout.spaceSeparator, articleRecircPipeSeparator],
        lower: [sharedStyles.layout.spaceSeparator, articleRecircPipeSeparator],
      },
    },
    compactContentCardThreeDailyReadPattern: {
      defaultSeparators: {
        upper: [sharedStyles.layout.spaceSeparator, ""],
        lower: [sharedStyles.layout.pipeSeparator, ""],
      },
    },
    compactContentCardThreeDailyReadPatternMobile: {
      defaultSeparators: {
        upper: [sharedStyles.layout.spaceSeparator, ""],
        lower: [sharedStyles.layout.pipeSeparator, ""],
      },
    },
  },
};

export default contentBlockMetaConfig;
